<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <AbstractPop :type-mo-full="true">
    <template v-slot>
      <div id="CYB_PC_PR_02_01" class="modal type-mo-full" data-popup>
        <div class="dialog type-large">
          <header class="dialog-header">
            <h2>
              <span class="sr-only">공지사항</span>
            </h2>
            <button
              type="button"
              class="dialog-close"
              data-popup-close
              @click="() => emits('close')"
            >
              <span class="c-icon icon-large-x"></span>
              <span class="sr-only">팝업 닫기</span>
            </button>
          </header>

          <div class="dialog-content">
            <div class="dialog-content-inner">
              <!-- D: MO에서만 존재 -->
              <h3 class="c-title-level3 only-mo">공지사항</h3>

              <!-- D: 공지사항 상세 -->
              <div class="c-notice-list" data-accordion-wrap data-mo-prevent>
                <div class="body">
                  <div class="item">
                    <button
                      type="button"
                      class="accordion-button"
                      data-accordion-trigger
                      aria-expanded="false"
                      aria-controls="act1"
                    >
                      <div class="td" style="--tb-width: 13%">
                        <span
                          v-if="props.data.imptYn == 'Y'"
                          class="c-flag type-board type-red"
                          >중요</span
                        >
                        <span
                          v-if="
                            props.data.imptYn == 'N' &&
                            props.data.ntcMttrTypeCd == '10'
                          "
                          class="c-flag type-board type-green"
                          >제품</span
                        >
                        <span
                          v-if="
                            props.data.imptYn == 'N' &&
                            props.data.ntcMttrTypeCd == '20'
                          "
                          class="c-flag type-board type-purple"
                          >사이트</span
                        >
                        <span
                          v-if="
                            props.data.imptYn == 'N' &&
                            props.data.ntcMttrTypeCd == '30'
                          "
                          class="c-flag type-board type-blue"
                          >유해화학</span
                        >
                        <span
                          v-if="
                            props.data.imptYn == 'N' &&
                            props.data.ntcMttrTypeCd == '40'
                          "
                          class="c-flag type-board type-olive"
                          >기타</span
                        >
                      </div>
                      <div class="td" style="--tb-width: 40%">
                        <strong class="title">{{
                          props.data.ntcMttrTitleNm
                        }}</strong>
                      </div>
                      <div class="td" style="--tb-width: 13%">
                        <span class="date">{{ props.data.regDt }}</span>
                      </div>
                      <div class="td" style="--tb-width: 13%">
                        <span class="hits">{{ props.data.inqCnt }}</span>
                      </div>
                      <div class="td" style="--tb-width: 13%">
                        <span class="confirm">
                          <span
                            :class="
                              props.data.idntyYn == 'Y'
                                ? 'color-primary'
                                : 'color-danger'
                            "
                            >{{ props.data.idntyYn }}</span
                          >
                        </span>
                      </div>
                    </button>
                    <div
                      id="act1"
                      class="accordion-content"
                      data-accordion-content
                      aria-hidden="false"
                    >
                      <div class="text" v-html="props.data.ntcMttrCn"></div>
                      <div
                        class="file-down-guide"
                        v-if="props.data.fileSn != 0"
                      >
                        관련 파일 다운로드 <br /><br />
                        파일명 :
                        <a
                          href="javascript:void(0);"
                          class="color-primary hover-underline"
                          @click="btnCmd()"
                          >{{ props.data.orgnlFileNm }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- // D: 공지사항 상세 -->
            </div>
          </div>
        </div>
        <!-- D: dimmed -->
        <div class="dimmed"></div>
      </div>
    </template>
  </AbstractPop>
</template>
<script setup name="moNoticeDetailPop">
import { defineProps, defineEmits } from "vue";
import * as cmApi from "@/api/cmApi";

import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
const emits = defineEmits(["close"]);
const props = defineProps({
  data: {},
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd() {
  cmApi.fileDownload(props.data);
}
</script>
